import { Title } from 'app/agriculture/components/Title/Title';
import { Subtitle } from 'app/agriculture/components/Subtitle/Subtitle';
import { InviteUsersForm } from 'app/agriculture/routes/BackOffice/Settings/components/InviteUsersForm';
import { BackOfficeContent } from 'app/agriculture/routes/BackOffice/BackOfficeContent';

export function FarmUserInvite() {
    return (
        <BackOfficeContent>
            <Title>Invite Users</Title>
            <Subtitle>Send an invite to new team members.</Subtitle>
            <InviteUsersForm />
        </BackOfficeContent>
    );
}
